const addQueryParam = (url, paramName, paramValue) => {
  const queryParam = url.includes('?') ? '&' : '?';
  const encodedValue = encodeURIComponent(paramValue);
  const updatedUrl = `${url}${queryParam}${paramName}=${encodedValue}`;
  return updatedUrl;
};

module.exports = addQueryParam;
